import {Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment.development';
import {RpReq} from "../interfaces/tipos";

const apiVucUrl = environment.apiVucUrl;

@Injectable({
    providedIn: 'root',
})
export class RpService {
    private apiUrl = apiVucUrl + `api/v1.0/registro-profesionales`;
    _openDlg = signal(false);

    constructor(private http: HttpClient) {
    }

    create(rpReq: RpReq) {
        return this.http.post<RpReq[]>(this.apiUrl, rpReq, {observe: 'response'});
    }
}
